import {
    LANES_KEY_PERFORMANCE_INDICATORS_REQUEST,
    LANES_KEY_PERFORMANCE_INDICATORS_SUCCESS,
    LANES_KEY_PERFORMANCE_INDICATORS_FAILURE
} from '../../actions/networkInsights/lanesKeyPerformanceIndicatorsActions';

interface LanesKeyPerformanceIndicators {
    isFetching: boolean;
    keyPerformanceIndicators: any;
}

const fetchLanesKeyPerformanceIndicatorsReducer = (lanesKeyPerformanceIndicatorsData: LanesKeyPerformanceIndicators = {
    isFetching: false,
    keyPerformanceIndicators: {}
}, action: any): LanesKeyPerformanceIndicators => {
    switch (action.type) {
        case LANES_KEY_PERFORMANCE_INDICATORS_REQUEST: {
            return {
                ...lanesKeyPerformanceIndicatorsData,
                isFetching: true
            };
        }
        case LANES_KEY_PERFORMANCE_INDICATORS_SUCCESS: {
            return {
                isFetching: false,
                keyPerformanceIndicators: action.payload
            };
        }
        case LANES_KEY_PERFORMANCE_INDICATORS_FAILURE: {
            return {
                isFetching: false,
                keyPerformanceIndicators: {}
            };
        }
        default:
            return lanesKeyPerformanceIndicatorsData;
    }
};

export default fetchLanesKeyPerformanceIndicatorsReducer;
